export const HEADER = {
  ICONED_LINK: 'header-iconed-link',
  CONTACT: 'contact',
  QUESTION: 'question',
  PRIMEUR: 'primeur',
  ADMIN: 'admin',
  ACCOUNT: 'account',
  CART: 'cart',
  LEAVE_CELLAR: 'leave-cellar',
  RETURN_TO_ACCOUNT: 'return-to-account',
  RETURN_TO_EXPRO: 'return-to-expro',
  DELIVERY_COUNTRY: 'delivery-country'
} as const;

export type Header = typeof HEADER [keyof typeof HEADER]

export const HEADER_COLORS = {
  default: '',
  highlight: 'highlight'
};

export const HEADER_TYPE = {
  BLOG: 'blog',
  CELLAR: 'cellar',
  CHECKOUT: 'checkout',
  CHECKOUTCSR: 'checkoutCsr',
  DEFAULT: 'default',
  PRIMEUR_CHECKOUT: 'primeur-checkout',
} as const;
